/**
 * The entry point of auth pages (login, reset password, etc.)
 */
import '@/apps/theme_sqq/main';
